import React from 'react';
/* eslint-disable max-len */
export function PaperIcon({ height = 24, width = 24, stroke = '#828A8F' }) {
  return (
    <svg
      fill='none'
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.26562 22.5469H19.7344C20.511 22.5469 21.1406 21.9173 21.1406 21.1406V8.36344C21.1405 7.99073 20.9925 7.63331 20.7291 7.36969L15.2241 1.86469C14.9604 1.60123 14.603 1.4532 14.2303 1.45312H4.26562C3.49969 1.45312 2.85938 2.09344 2.85938 2.85938V21.1406C2.85938 21.9066 3.49969 22.5469 4.26562 22.5469Z'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M21.1406 8.48438H15.5156C15.1427 8.48438 14.7849 8.33621 14.5212 8.07249C14.2575 7.80877 14.1094 7.45108 14.1094 7.07812V1.45312'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  );
}
/* eslint-enable max-len */
